/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { INotificationProps } from '../../notification-components';
import { BaseNotification } from './base-notification';

/**
 * Decorator which should be used to specify the react component class for a notification data instances.
 * @param {React.ComponentClass<PropsType, StateType>} componentClass The component class responsible for rendering all the data instances of this notification class.
 */
export const withNotificationComponent = <
    NotificationType extends BaseNotification,
    PropsType extends INotificationProps<NotificationType>,
    StateType extends {}>(
    componentClass: React.ComponentClass<PropsType, StateType>) => {

    return <T extends new(...args: any[]) => {}>(constructor: T) => {
        return class extends constructor {
            public readonly notificationComponentConstructor: React.ComponentClass<PropsType, StateType> = componentClass;
        };
    };
};

